import { usePartnerMissionStore } from "../../../../stores/Cac/Partner/partnerMission";
import "../../../../css/animations.css";

const UploadMission = () => {
  const { dataMission, setDataMission, checkboxRelaunchAuto, setCheckboxRelaunchAuto } = usePartnerMissionStore();

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      setDataMission({ ...dataMission, file: file });
    }
  };

  return (
    <div className="w-11/12 m-auto flex justify-between items-center">
      <div className="w-auto flex flex-col justify-start items-start mb-4">
        <p className="text-sm font-medium text-gray-700 mb-2">Télécharger la lettre de mission :</p>
        <div className="relative">
          <input
            type="file"
            name="doc"
            id="fileUpload"
            onChange={handleUpload}
            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            accept=".pdf,.doc,.docx"
          />
          <label 
            htmlFor="fileUpload" 
            className="flex items-center justify-center gap-2 px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg cursor-pointer transition-colors duration-200 shadow-sm hover:shadow-md"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
            </svg>
            {dataMission.file ? "Changer de fichier" : "Choisir un fichier"}
          </label>
          <p className="text-xs text-gray-500 mt-2">Formats acceptés : PDF, DOC, DOCX</p>
        </div>
      </div>
      {/* Affichage du nom du fichier sélectionné */}
      {dataMission.file ? (
      <div className="1/2 flex flex-col justify-start items-start mb-4 ml-4">
      <p className="text-sm font-medium text-gray-700 ">Fichier sélectionné : </p>
            <div className="flex items-center justify-between ">
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="text-sm font-medium text-green-800 truncate">{dataMission.file.name}</span>
              </div>
              <button
                onClick={() => {
                  setDataMission({ ...dataMission, file: undefined });
                  const fileInput = document.getElementById('fileUpload') as HTMLInputElement;
                  if (fileInput) {
                    fileInput.value = '';
                  }
                }}
                className="p-1 text-red-500 hover:text-red-700 hover:bg-red-100 rounded-full transition-colors duration-200"
                title="Supprimer le fichier"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
      </div>
      ):null}
    </div> 
  );
};

export default UploadMission;
